import React from 'react';

import SalonSpinner from 'components/generic/SalonSpinner.component';

const InlineSpinner = (props) => <SalonSpinner {...props} />;

export default InlineSpinner;
